import { QuillMentionMatch } from './quill-mention-match';

export class QuillMentionUtils {
  public static RenderMcMentionItem<T extends QuillMentionMatch>(item: T, showAvatar = true) {
    const mention = document.createElement('div');
    mention.style.display = 'flex';
    mention.style.alignItems = 'center';
    if (item.additionalClass) {
      mention.classList.add(item.additionalClass);
    }

    // Any svg-backed item (groups, channels, @here/@channel, slash commands)
    // renders its icon in a muted, bordered, rounded box instead of the circular
    // avatar treatment, so svg mentions read consistently everywhere this
    // renderer is used.
    const isBoxedIcon = !!item.svgIcon && !item.avatarUrl;

    const avatar = document.createElement(item.avatarUrl ? 'img' : 'div');
    const name = document.createElement('p');
    const firstInitial = ((item.avatarName || item.value)[0] || '').toUpperCase();

    const avatarContainer = document.createElement('div');
    avatarContainer.classList.add('spaces-quill-mention-avatar-container');

    if (item.avatarUrl) {
      (avatar as HTMLImageElement).src = item.avatarUrl;
      (avatar as HTMLImageElement).alt = firstInitial;
    } else if (item.svgIcon) {
      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(item.svgIcon, 'image/svg+xml');
      const svgElement = svgDoc.documentElement;
      avatar.appendChild(svgElement);
      avatar.classList.add('svg-icon');
      if (item.svgIconClass) {
        avatar.classList.add(item.svgIconClass);
      } else if (item.avatarColor !== undefined) {
        avatar.classList.add(`color-preset-${item.avatarColor}`);
      }
      if (isBoxedIcon) {
        avatar.classList.add(
          'spaces-quill-mention-icon-box',
          'pad-050',
          'border-radius-075',
          'border-muted',
          'surface-muted',
        );
      }
    } else {
      const initialEl = document.createElement('span');
      initialEl.classList.add('initials-background');
      avatar.classList.add(`scheme-${item.avatarColor}`);

      initialEl.innerText = firstInitial;
      (avatar as HTMLDivElement).appendChild(initialEl);
    }

    name.innerText = item.listItemDisplay || item.value;
    if (item.listItemDescription) {
      name.classList.add('spaces-quill-mention-name-with-description');
      const description = document.createElement('span');
      description.classList.add('spaces-quill-mention-description');
      description.innerText = item.listItemDescription;
      name.appendChild(description);
    }
    if (!isBoxedIcon) {
      avatar.classList.add('spaces-quill-mention-avatar');
    }
    if (item.avatarShape === 'squircle') {
      avatar.classList.add('squircle');
    }

    name.classList.add('spaces-quill-mention-name');

    if (item.isApp) {
      const appBadge = document.createElement('span');
      appBadge.classList.add('mdw-badge', 'mdw-app-badge');
      appBadge.innerText = 'APP';
      name.appendChild(appBadge);
    }

    const email = document.createElement('p');
    email.classList.add('extra-small', 'secondary', 'medium');
    email.innerText = item.secondaryValue || '';

    const nameContainer = document.createElement('div');
    nameContainer.appendChild(name);
    if (item.secondaryValue) {
      nameContainer.appendChild(email);
    }

    // Boxed icons are appended directly (no circular avatar container), so the
    // box sizes to the icon + padding rather than the fixed 24px avatar slot.
    if (isBoxedIcon) {
      if (showAvatar) {
        mention.appendChild(avatar);
      }
    } else {
      avatarContainer.appendChild(avatar);
      if (showAvatar) {
        mention.appendChild(avatarContainer);
      }
    }
    mention.appendChild(nameContainer);

    if (item.statusSvg) {
      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(item.statusSvg, 'image/svg+xml');
      const svgElement = svgDoc.documentElement;
      avatar.classList.add('show-status');
      svgElement.classList.add('spaces-quill-mention-item-status');
      if (item.isConnectedUser) {
        svgElement.classList.add('connected-user-icon');
      }
      if (item.isGuestUser) {
        svgElement.classList.add('guest-icon');
      }

      name.appendChild(svgElement);
    }

    return mention;
  }
}
